import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from '@app/services/shared/user.service';
import {appConfig} from "@app/shared/configs/app-config";

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss']
})
export class ContentHeaderComponent implements OnInit {

  pageTitle: string = null;
  pageSubtitle: string = null;
  showTitleBar: boolean = false;

  //we need to move this function table
  private titleBarHiddenRoutesExactMatch: string[] = ['/help/faq', '/dashboard'];
  private titleBarHiddenRoutesBaseMatch: string[] = ['/drawing-helper', '/help/helpcenter', '/help/pagecontent?'];
  private urlCheckExcemptRoutes: string[] = ['/dashboard', '/help', '/clouddrive/', '/departmenttickets', '/mytickets', '/lock'];

  constructor(private router: Router,
    private cd: ChangeDetectorRef,
    private userService: UserService) {
    router.events
      .pipe(
        filter(
          (event) => {
            return (event instanceof NavigationEnd);
          }
        )
      )
      .subscribe(
        (event: NavigationEnd) => {
          if(event.url === "/") {
            userService.hasPermissionForUrl('/drawing-helper/drawing-helper').subscribe(result => {
              if (result)
                this.router.navigate(['/drawing-helper/drawing-helper']);
              else
                this.router.navigate(['/dashboard']);
            });
          }

          userService.getUserFunctionByUrl(event.url).subscribe(functionModel => {
            if (this.titleBarHiddenRoutesExactMatch.findIndex(x => x === event.url) >= 0 ||
              this.titleBarHiddenRoutesBaseMatch.findIndex(x => event.url.includes(x)) >= 0 ||
              !functionModel) {
              this.showTitleBar = false;
            } else if (functionModel) {
              this.pageTitle = functionModel.pageTitle;
              this.pageSubtitle = functionModel.pageSubtitle;
              this.showTitleBar = true;
              this.cd.detectChanges();
            }

            //we need a regex for removing query params
            if ( !this.containsAny(event.url, this.urlCheckExcemptRoutes)) {
              userService.hasPermissionForUrl(event.url).subscribe(result => {
                if (!result) {
                  this.router.navigate(["/500"]);
                  this.showTitleBar = false;
                }
              });
            }
          });
        }
      );
  }

  ngOnInit() {
  }

  private containsAny(str, substrings) {
    for (var i = 0; i != substrings.length; i++) {
      var substring = substrings[i];
      if (str.indexOf(substring) != - 1) {
        return substring;
      }
    }
    return null;
  }

}
